import { ProximityToHomeData } from '@components/Dashboard/CampaignAnalytics/slice/schema';
import { CA_LIGHT_BLUE_COLOR } from '@utils/colorGenerator';
import { AXIS_COLOR, baseChart } from './baseChart';
import { SUBHEADER_FONT_SIZE } from '@components/shared/Layout/ReportSectionCardHeader';
import Highcharts from 'highcharts';
import { ValueInput, formatters } from '@utils/formattersV2';

const DECIMAL_COUNT = 0;

const formatter = (value: ValueInput): string =>
  formatters.percentage(value, { decimals: DECIMAL_COUNT });

export const buildChartOptions = (
  sortedDataItems: ProximityToHomeData[],
  options?: {
    dataLabelsEnabled?: boolean;
  }
): Highcharts.Options => ({
  ...baseChart,

  chart: {
    type: 'column',
  },

  series: [
    {
      type: 'column',
      dataLabels: {
        enabled: options?.dataLabelsEnabled ?? false,
        formatter() {
          return formatter(this.y);
        },
        style: {
          fontWeight: 'normal',
        },
      },
      data: sortedDataItems.map(dataItem => ({
        name: dataItem.name,
        y: dataItem.value,
      })),
      borderRadius: 5,
      color: CA_LIGHT_BLUE_COLOR,
    },
  ],

  tooltip: {
    enabled: true,
    formatter() {
      return formatter(this.y);
    },
  },

  xAxis: {
    type: 'category',
    gridLineWidth: 0,
    labels: {
      style: {
        fontSize: SUBHEADER_FONT_SIZE,
      },
    },
  },

  yAxis: {
    gridLineWidth: 0,
    lineColor: AXIS_COLOR,
    lineWidth: 1,
    labels: {
      formatter() {
        return formatter(Number.parseFloat(this.value.toString()));
      },
      style: {
        fontSize: SUBHEADER_FONT_SIZE,
      },
    },
    title: {
      text: undefined,
    },
  },
});
